import { useSupabaseClient } from '#imports'

export default defineNuxtRouteMiddleware(async (to) => {
    // Only check if the route has meta.public set to true
    if (!to.meta.public) return

    const supabase = useSupabaseClient()
    const { data: session } = await supabase.auth.getUser()

    if (session?.user) {
        return navigateTo('/dashboard')
    }
})
